import { createRoot } from 'react-dom/client';
import Root from './root';
import './styles/index.css';
import 'bootstrap/dist/css/bootstrap.css';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<Root />);
